var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadview"},[_c('div',{attrs:{"id":"load"}},[(_vm.view)?_c('span',[_vm._v("Wallpaper")]):_vm._e(),(_vm.view)?_c('span',{staticClass:"by"},[_vm._v("By "+_vm._s(_vm.author))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0ca252b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/loadview.vue
// module id = null
// module chunks = 